@use "../../scss/breakpoints";
@use "../../scss/colors";
@use "../../scss/utilities";

.trigger {
	// Clear default button styling
	all: unset;
	cursor: pointer;
	display: inline-flex;
	gap: 4px;

	&[data-open="true"] {
		i {
			transform: rotate(180deg);
		}
	}
}

.dropdown {
	position: fixed;
	inset: auto;
	margin: 0;
	border: none;
	top: calc(anchor(bottom) + var(--dropdown-offset));
	background-color: colors.$white;
	box-shadow: utilities.$box-shadow;
	padding: 8px;
	z-index: 10;
	border: 1px solid colors.$nordic_light_grey;

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
		li {
			a {
				display: block;
				clear: both;
				line-height: 24px;
				font-size: 16px;
				font-weight: 350;
				letter-spacing: 1.1px;
				color: colors.$nordic_dark_grey;
				white-space: nowrap;
				cursor: pointer;
				padding: 8px 16px 8px 16px;
				&:hover,
				&:focus-visible {
					color: colors.$nordic_lake;
					background-color: colors.$nordic_light_grey;
				}
			}
		}
	}

	// Closed state (also the exit-animation target)
	opacity: 0;
	transform: translateY(-8px) scale(0.95);
	transform-origin: top;
	transition:
		opacity 0.2s ease-out,
		transform 0.2s ease-out,
		overlay 0.2s ease-out allow-discrete,
		display 0.2s ease-out allow-discrete;

	&:popover-open {
		opacity: 1;
		transform: translateY(0) scale(1);

		// Entry-animation starting point — the browser snapshots these
		// values on the frame the popover is shown, then transitions
		// to the :popover-open values above.
		@starting-style {
			opacity: 0;
			transform: translateY(-8px) scale(0.95);
		}
	}

	// Respect users who prefer reduced motion: keep the opacity fade
	// (a non-motion cue) but skip the slide/scale transforms.
	@media (prefers-reduced-motion: reduce) {
		transform: none;

		&:popover-open {
			transform: none;

			@starting-style {
				transform: none;
			}
		}
	}
}

.alignStart {
	left: anchor(left);
}

.alignCenter {
	left: anchor(center);
	translate: calc(calc(1 / 2 * 100%) * -1) 0;
}

.alignEnd {
	right: anchor(right);
}
